import { Component, ErrorInfo, ReactNode } from 'react';
import { Box, Text } from '@bpba/ui-components';

type Props = { children: ReactNode; fallback?: ReactNode };
type State = { hasError: boolean };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <Box
            role="alert"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="60vh"
            p={5}
            style={{ gap: '12px', textAlign: 'center' }}
          >
            <Text fontSize="14px" color="secondary.1" style={{ opacity: 0.7 }}>
              Ocurrió un error, intentá nuevamente en unos minutos.
            </Text>
          </Box>
        )
      );
    }
    return this.props.children;
  }
}
